module.exports = __webpack_public_path__ + "6c6d1f136a81384bd64f00a16f136cc9.svg";